__webpack_require__.p = "/reports-legacy-remove-broken-link/referrals-hub/";